<template>
  <div class="audio-player">
    <audio :src="src"
      controls
      class="audio-hidden"
      ref="audio"
      @play="onPlay"
      @pause="onPause"
      @loadedmetadata="onLoadedmetadata"
      @timeupdate="onTimeupdate"></audio>
    <div class="player-control">
      <div class="play-button" @click="startPlayOrPause">
        <i :class="['play-icon', playing ? 'pause' : 'play']"></i>
      </div>
      <div class="audio-control-main">
        <div class="audio-title"><img src="/Application/Home/Resource/static/images/audio-title.png"></div>
        <div class="progress-bar">
          <div class="bar" @click="onSeekBarClick($event)" ref="vscVpSeekar">
            <div class="progress" :style="{width: sliderTime + '%'}">
              <div class="bar-point" @click="onbarPointClick($event)" @mousedown="onbarPointDgDown($event)"></div>
            </div>
          </div>
          <div class="progress-time">{{remainTime}} / {{maxTime}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .audio-player{
    .audio-hidden{
      display: none;
    }
    .player-control{
      width: 100%;
      height: 50px;
      background: linear-gradient(270deg,rgba(43,124,235,1) 0%,rgba(88,186,234,1) 100%);
      border-radius: 46px;
      padding-left: 9px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .play-button{
        width: 34px;
        height: 34px;
        background: #FFF;
        box-shadow: 0px 0px 12px 0px rgba(20,71,133,0.81);
        border-radius: 50%;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        .play-icon{
          position: relative;
          width: 10px;
          height: 12px;
          &.play::after{
            content: '';
            position: absolute;
            left: 1px;
            top: 0;
            width: 0;
            height: 0;
            border-width: 6px 10px;
            border-style: dashed dashed dashed solid;
            border-color: transparent transparent transparent #3083EB;
          }
          &.pause::after{
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 3px;
            height: 100%;
            background: #3083EB;
            box-shadow: 6px 0 0 0 #3083EB;
          }
        }
      }
      .audio-control-main{
        margin-left: 8px;
        flex: 1;
        height: 40px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding-top: 3px;
        background: url('/Application/Home/Resource/static/images/audio-bg.png') no-repeat center center;
        background-size: cover;
        .audio-title{
          height: 14px;
          margin-bottom: 7px;
          margin-left: 6px;
          img{
            height: 100%;
          }
        }
        .progress-bar{
          display: flex;
          align-items: center;
          justify-content: flex-start;
          .bar{
            position: relative;
            width: 1.94rem;
            height: 8px;
            display: flex;
            align-items: center;
            margin-left: 6px;
            cursor: pointer;
            &::after{
              content: '';
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 100%;
              height: 4px;
              background: #FFF;
              border-radius: 2px;
            }
            .progress{
              position: relative;
              height: 4px;
              background: #3083EB;
              border-radius: 2px 0 0 2px;
              z-index: 5;
              // transition: all .2s;
              .bar-point{
                position: absolute;
                right: -3px;
                top: -2px;
                width: 3px;
                height: 8px;
                background: #FFF;
              }
            }
          }
          .progress-time{
            font-size: 12px;
            color: #FFF;
            margin-left: 3px;
            transform: scale(.9);
          }
        }
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    props: {
      src: String,
    },
    data() {
      return {
        theUrl: this.src,
        playing: false,
        maxTime: 0,
        currentTime: 0,
        sliderTime: 0,
        draging: false,
      }
    },
    computed: {
      remainTime() {
        return this.formatTime(this.currentTime);
      }
    },
    created() {},
    mounted() {},
    methods: {
      formatTime(time) {
        let secondType = typeof time;
        let second = parseInt(time);
        if(second === 0) return '00:00';
        if (secondType === "number" || secondType === "string") {
          console.log(second)
          var mimute = Math.floor(second / 60);
          second = second - mimute * 60;
          return `${('0' + mimute).slice(-2)}:${('0' + second).slice(-2)}`;
        } else {
          return '00:00';
        }
      },
      startPlayOrPause() {
        this.playing ? this.pausePlay() : this.startPlay();
      },
      // 开始播放
      startPlay() {
        this.$refs.audio.play();
      },
      // 暂停
      pausePlay() {
        this.$refs.audio.pause();
      },
      onPlay(res) {
        this.playing = true;
        let target = res.target;
      },
      onPause(res) {
        this.playing = false;
      },
      // 当加载语音流元数据完成后，会触发该事件的回调函数
      // 语音元数据主要是语音的长度之类的数据
      onLoadedmetadata(res) {
        console.log(res.target.duration)
        this.maxTime = this.formatTime(parseInt(res.target.duration));
      },
      onTimeupdate(res) {
        this.currentTime = res.target.currentTime;
        this.sliderTime = parseInt((this.currentTime / res.target.duration) * 100);
      },
      onSeekBarClick(e) {
        let left = this.$refs.vscVpSeekar.getBoundingClientRect().left;
        this.sliderTime = parseInt(((e.clientX - left) / this.$refs.vscVpSeekar["clientWidth"]) * 100);
        this.$refs.audio.currentTime = (this.sliderTime / 100) * this.$refs.audio.duration;
      },
      onbarPointClick(e) {
        e.stopPropagation ? e.stopPropagation() : (e.cancelBubble = true);
      },
      onbarPointDgDown(e) {
        e.preventDefault();
        this.draging = true;
        window.addEventListener("mouseup", this.onDragEnd);
        window.addEventListener("mousemove", this.onDragging);
      },
      onDragEnd() {
        if (this.draging == true) {
          this.draging = false;
        }
        window.removeEventListener("mouseup", this.onDragEnd);
        window.removeEventListener("mousemove", this.onDragging);
      },
      onDragging(e) {
        if (this.draging) {
          let left = this.$refs.vscVpSeekar.getBoundingClientRect().left;
          if (e.clientX - left < this.$refs.vscVpSeekar["clientWidth"]) {
            this.onSeekBarClick(e);
          }
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/audioPlayer.vue